import React, { useEffect, useState } from "react";
import {
  Box,
  Container,
  Typography,
  Paper,
  Button,
  Grid,
  useMediaQuery,
  IconButton,
  Select,
  MenuItem,
  ListItemText,
  Checkbox,
  TextField,
} from "@mui/material";
import ChevronLeftOutlined from "@mui/icons-material/ChevronLeftOutlined";
import { DateRangePicker } from "@mui/x-date-pickers-pro";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
const Filter = ({
  filters = [],
  setFilters = () => {},
  type,
  data,
  setFilterState,
}) => {
  const [selectDate, setSelectDate] = useState([]);
  const [localFilters, setLocalFilters] = useState(() => ({
    ...filters,
    submit: filters.submit || [], // Ensure submit is an array
    insight: filters.insight || [],
    startDate: filters.startDate || "",
    endDate: filters.endDate || "",
  }));
  useEffect(() => {
    if (localFilters.startDate && localFilters.endDate)
      setSelectDate([localFilters.startDate, localFilters.endDate]);
  }, [localFilters.startDate, localFilters.endDate]);
  const handleToggle = (selectedArray, key, value) => {
    setLocalFilters((prev) => {
      const currentArray = prev[key] || [];
      const updatedArray = currentArray.includes(value)
        ? currentArray.filter((item) => item !== value)
        : value;
      return {
        ...prev,
        [key]: updatedArray,
      };
    });
  };
  const handleDateRangeChange = (newValue) => {
    const [start, end] = newValue;
    setLocalFilters((prev) => ({
      ...prev,
      startDate: start || "",
      endDate: end || "",
    }));
    setSelectDate(newValue);
  };
  return (
    <Container
      maxWidth="xs"
      sx={{
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#ecf0f7",
        padding: "0 20px",
        height: "100vh",
      }}
    >
      <Box
        sx={{
          height: "129px",
          backgroundColor: "#1C1468",
          color: "white",
          display: "flex",
          alignItems: "center",
          marginLeft: "-24px",
          marginRight: "-24px",
          zIndex: 3,
          justifyContent: "space-between",
          position: "fixed",
          width: useMediaQuery("(min-width:600px)")
            ? "444px"
            : "calc(100vw + 10px)",
        }}
      >
        <IconButton
          edge="start"
          sx={{ marginLeft: "10px" }}
          color="inherit"
          onClick={() =>
            setFilterState((prev) => ({ ...prev, isFilter: false }))
          }
        >
          <ChevronLeftOutlined />
        </IconButton>

        <Typography sx={{ fontSize: "16px" }} variant="h5" fontWeight="bold">
          Filter
        </Typography>

        <IconButton
          edge="end"
          color="inherit"
          sx={{ marginRight: "15px" }}
        ></IconButton>
      </Box>

      {type === "submit" && (
        <Paper
          sx={{ padding: "16px", marginTop: "159px", marginBottom: "20px" }}
        >
          <Typography variant="h6" fontWeight="bold" gutterBottom>
            Status
          </Typography>
          <Box
            sx={{ display: "flex", gap: 2, mb: 2 }}
            onClick={(e) => e.stopPropagation()}
          >
            <Select
              multiple
              value={localFilters.submit}
              onChange={(e) =>
                handleToggle(localFilters.submit, "submit", e.target.value)
              }
              displayEmpty
              fullWidth
              renderValue={(selected) => {
                if (selected.length === 0) {
                  return `All Statuses (${data.hazards + data.incidents + data.accidents})`; // Placeholder when nothing is selected
                }
                return selected.join(", "); // Display selected options as a comma-separated string
              }}
              sx={{ minWidth: 120 }}
            >
              <MenuItem value="hazard">
                <ListItemText primary={`Hazard (${data.hazards})`} />
                <Checkbox checked={localFilters.submit.includes("hazard")} />
              </MenuItem>
              <MenuItem value="incident">
                <ListItemText primary={`Incident (${data.incidents})`} />
                <Checkbox checked={localFilters.submit.includes("incident")} />
              </MenuItem>
              <MenuItem value="accident">
                <ListItemText primary={`Accident (${data.accidents})`} />
                <Checkbox checked={localFilters.submit.includes("accident")} />
              </MenuItem>
            </Select>
          </Box>
        </Paper>
      )}
      {type === "insight" && (
        <Box gap={2}>
          <Paper
            sx={{ padding: "16px", marginTop: "159px", marginBottom: "20px" }}
          >
            <Typography variant="h6" fontWeight="bold" gutterBottom>
              Status
            </Typography>
            <Box
              sx={{ display: "flex", gap: 2, mb: 2 }}
              onClick={(e) => e.stopPropagation()}
            >
              <Select
                multiple
                value={localFilters.insight}
                onChange={(e) => {
                  e.stopPropagation(); // Prevents parent click event
                  handleToggle(localFilters.insight, "insight", e.target.value);
                }}
                displayEmpty
                fullWidth
                renderValue={(selected) => {
                  if (selected.length === 0) {
                    return "All Statuses"; // Placeholder when nothing is selected
                  }
                  return selected.join(", "); // Display selected options as a comma-separated string
                }}
                sx={{ minWidth: 120 }}
              >
                <MenuItem value="Approved">
                  <ListItemText primary={`Approved (${data.approved})`} />
                  <Checkbox
                    checked={localFilters.insight.includes("Approved")}
                  />
                </MenuItem>
                <MenuItem value="Queried">
                  <ListItemText primary={`Queried (${data.queried})`} />
                  <Checkbox
                    checked={localFilters.insight.includes("Queried")}
                  />
                </MenuItem>
                <MenuItem value="Pending">
                  <ListItemText primary={`Pending (${data.pendings})`} />
                  <Checkbox
                    checked={localFilters.insight.includes("Pending")}
                  />
                </MenuItem>
              </Select>
            </Box>
          </Paper>
          <Paper
            sx={{ padding: "16px", marginTop: "10px", marginBottom: "20px" }}
          >
            <Typography variant="h6" fontWeight="bold" gutterBottom>
              Date
            </Typography>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <Box
                sx={{ display: "flex", gap: 2, mb: 2 }}
                onClick={(e) => e.stopPropagation()}
              >
                {/* <MobileDatePicker
                  label="Start Date"
                  type="date"
                  InputLabelProps={{ shrink: true }}
                  value={localFilters.startDate}
                  onChange={(e) => {
                    e.stopPropagation(); // Prevents parent click event
                    setLocalFilters((prev) => ({
                      ...prev,
                      startDate: e.target.value,
                    }));
                  }}
                />

                <MobileDatePicker
                  label="End Date"
                  InputLabelProps={{ shrink: true }}
                  value={localFilters.endDate}
                  onChange={(e) => {
                    e.stopPropagation(); // Prevents parent click event
                    setLocalFilters((prev) => ({
                      ...prev,
                      endDate: e.target.value,
                    }));
                  }}
                /> */}
                <DateRangePicker
                  calendars={2}
                  name="dateRange"
                  value={selectDate}
                  onChange={handleDateRangeChange}
                  format="DD/MM/YYYY"
                  renderInput={(startProps, endProps) => (
                    <>
                      <TextField
                        {...startProps}
                        helperText="Start date (DD/MM/YYYY)"
                      />
                      <Box sx={{ mx: 2 }}> to </Box>
                      <TextField
                        {...endProps}
                        helperText="End date (DD/MM/YYYY)"
                      />
                    </>
                  )}
                />
              </Box>
            </LocalizationProvider>
          </Paper>
        </Box>
      )}

      {/* <Paper sx={{ padding: "16px", marginTop: "159px", marginBottom: "20px" }}>
        <Typography variant="h6" fontWeight="bold" gutterBottom>
          Status
        </Typography>
        <ToggleButtonGroup
          value={localFilters.status || []}
          onChange={(event, value) =>
            handleToggle(localFilters.status, "status", value)
          }
          sx={{ display: "flex", justifyContent: "space-between" }}
        >
          <ToggleButton value="not_started">Not started</ToggleButton>
          <ToggleButton value="in_progress">In progress</ToggleButton>
          <ToggleButton value="completed">Completed</ToggleButton>
        </ToggleButtonGroup>
      </Paper>

      <Paper sx={{ padding: "16px", marginBottom: "20px" }}>
        <Typography variant="h6" fontWeight="bold" gutterBottom>
          Project
        </Typography>
        <Grid container spacing={2}>
          {["Project A", "Project B", "Project C"].map((project) => (
            <Grid item xs={4} key={project}>
              <Button
                variant={
                  localFilters.projects?.includes(project)
                    ? "contained"
                    : "outlined"
                }
                fullWidth
                onClick={() =>
                  handleToggle(localFilters.projects, "projects", project)
                }
              >
                {project}
              </Button>
            </Grid>
          ))}
        </Grid>
      </Paper> */}

      <Box sx={{ flexGrow: 1 }} />
      <Button
        variant="contained"
        fullWidth
        sx={{
          backgroundColor: "#1C1468",
          color: "white",
          textTransform: "capitalize",
          fontWeight: "bold",
          padding: "15px",
          marginBottom: "20px",
        }}
        onClick={() => {
          setFilterState((prev) => ({ ...prev, isFilter: false }));
          setFilters(localFilters);
        }}
      >
        Show all results
      </Button>
    </Container>
  );
};

export default Filter;
